import { render, staticRenderFns } from "./verify_email.vue?vue&type=template&id=50d1b9f2&"
import script from "./verify_email.vue?vue&type=script&lang=js&"
export * from "./verify_email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports